/**
 * The one rule for names an author types in: course, theme and course part.
 * The API enforces the same minimum (`NameRules` in LaraNara.Author.Services), this is
 * the editor side so an empty or one-letter name never gets sent.
 */
export const MIN_NAME_LENGTH = 2;

const NAME_MIN_CHARS_KEY = "min.x.chars";

/** At least MIN_NAME_LENGTH characters once surrounding white space is removed. */
export function isValidName(name: string | null | undefined): boolean {
    return (name ?? "").trim().length >= MIN_NAME_LENGTH;
}

/**
 * The message shown under a name field that breaks the rule. The text key arrives with
 * dbMigrations/005-name-min-chars.sql in lnserver; until a database has it, getText hands
 * back the bare key, so fall back to English rather than show that.
 */
export function nameTooShortText(t: { getText: (key: string, ...args: string[]) => string }): string {
    const text = t.getText(NAME_MIN_CHARS_KEY, String(MIN_NAME_LENGTH));
    return text && text !== NAME_MIN_CHARS_KEY
        ? text
        : `The name must be at least ${MIN_NAME_LENGTH} characters`;
}
